/* ===========================================================================
   Pawtrait Pop — theme behaviour
   No dependencies. Everything degrades gracefully without JS:
   the product form is a plain multipart POST to /cart/add.
   =========================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------ mobile drawer -- */
  function initDrawer() {
    var drawer = document.querySelector('[data-pp-drawer]');
    if (!drawer) return;
    var openers = document.querySelectorAll('[data-pp-drawer-open]');
    var closers = drawer.querySelectorAll('[data-pp-drawer-close]');
    var lastFocused = null;

    function open() {
      lastFocused = document.activeElement;
      drawer.dataset.open = 'true';
      drawer.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      var first = drawer.querySelector('a, button');
      if (first) first.focus();
    }
    function close() {
      drawer.dataset.open = 'false';
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (lastFocused) lastFocused.focus();
    }

    openers.forEach(function (b) { b.addEventListener('click', open); });
    closers.forEach(function (b) { b.addEventListener('click', close); });
    drawer.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.dataset.open === 'true') close();
    });
  }

  /* ---------------------------------------------------- reveal on scroll -- */
  function initReveal() {
    var els = document.querySelectorAll('.pp-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el) { io.observe(el); });

    /* Failsafe: whatever happens, nothing stays invisible. If the observer has
       not revealed an element within 1.5s, show it anyway. */
    window.setTimeout(function () {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }, 1500);
  }

  /* -------------------------------------------------------- product form -- */
  function initProduct() {
    var root = document.querySelector('[data-pp-product]');
    if (!root) return;

    var form = root.querySelector('[data-pp-form]');
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var priceEls = root.parentNode ? document.querySelectorAll('[data-pp-price]') : [];
    var maxBytes = parseInt(root.dataset.maxUploadMb || '20', 10) * 1024 * 1024;

    /* -- variant pills keep the hidden id + every price display in sync -- */
    var variantData = {};
    var json = root.querySelector('[data-pp-variants]');
    if (json) {
      try {
        JSON.parse(json.textContent).forEach(function (v) { variantData[v.id] = v; });
      } catch (e) { /* leave prices as server-rendered */ }
    }

    root.querySelectorAll('[data-pp-variant]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        if (idInput) idInput.value = input.value;
        var v = variantData[input.value];
        if (v && v.price_formatted) {
          priceEls.forEach(function (el) { el.textContent = v.price_formatted; });
        }
      });
    });

    /* ------------------------------------------ photo upload + preview -- */
    var zone = root.querySelector('[data-pp-upload]');
    if (zone) {
      var input = zone.querySelector('input[type="file"]');
      var preview = zone.querySelector('[data-pp-preview] img');
      var nameEl = zone.querySelector('[data-pp-filename]');
      var errEl = root.querySelector('[data-pp-upload-error]');

      function fail(message) {
        if (errEl) { errEl.textContent = message; errEl.dataset.show = 'true'; }
        zone.dataset.hasFile = 'false';
        if (input) input.value = '';
      }
      function clearError() { if (errEl) errEl.dataset.show = 'false'; }

      function handle(file) {
        clearError();
        if (!file) return;
        if (!/^image\//.test(file.type)) {
          fail('That file is not an image — please upload a JPG, PNG, HEIC or WebP photo.');
          return;
        }
        if (file.size > maxBytes) {
          fail('That photo is a little too big. Please upload one under ' + (maxBytes / 1024 / 1024) + 'MB.');
          return;
        }
        if (nameEl) nameEl.textContent = file.name;
        zone.dataset.hasFile = 'true';
        if (preview && window.FileReader) {
          var reader = new FileReader();
          reader.onload = function (e) { preview.src = e.target.result; };
          reader.readAsDataURL(file);
        }
      }

      if (input) {
        input.addEventListener('change', function () { handle(input.files && input.files[0]); });
      }
      ['dragenter', 'dragover'].forEach(function (t) {
        zone.addEventListener(t, function (e) { e.preventDefault(); zone.dataset.drag = 'true'; });
      });
      ['dragleave', 'drop'].forEach(function (t) {
        zone.addEventListener(t, function (e) { e.preventDefault(); zone.dataset.drag = 'false'; });
      });
      zone.addEventListener('drop', function (e) {
        var files = e.dataTransfer && e.dataTransfer.files;
        if (!files || !files.length) return;
        if (input) {
          try { input.files = files; } catch (err) { /* older browsers: fall back to click */ }
        }
        handle(files[0]);
      });

      /* Guard the submit so a missing photo never silently reaches checkout. */
      if (form) {
        form.addEventListener('submit', function (e) {
          if (input && input.required && !(input.files && input.files.length)) {
            e.preventDefault();
            fail('Please add a photo of your pet so we know who we are drawing.');
            zone.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          }
        });
      }
    }

    /* ------------------------------------------- sticky mobile add-to-cart */
    var sticky = root.querySelector('[data-pp-sticky]');
    var anchor = root.querySelector('[data-pp-atc-anchor]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      var so = new IntersectionObserver(function (entries) {
        sticky.dataset.show = entries[0].isIntersecting ? 'false' : 'true';
      }, { rootMargin: '-120px 0px 0px 0px' });
      so.observe(anchor);
    }
  }

  /* ------------------------------------------------------- cart quantity -- */
  function initCart() {
    document.querySelectorAll('[data-pp-qty-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var form = input.closest('form');
        if (form) form.submit();
      });
    });
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn, { once: true });
  }

  ready(function () {
    initDrawer();
    initReveal();
    initProduct();
    initCart();
  });
})();
